import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { provideAnimations } from '@angular/platform-browser/animations';
import Aura from '@primeng/themes/aura';
import { appRoutes } from './app.routes';
import { CRBytesPrimeNGAdminConsoleLayoutPreferenceStorageService, provideCRBytePrimeNGAdminConsoleConfig } from '@cr-bytes/primeng-admin-console';
import { FooterComponent } from './footer.component';
import { LayoutStorageService } from './layoutStorage.service';
import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
    providers: [
      MessageService,
        provideCRBytePrimeNGAdminConsoleConfig({
            logoUrl: '/assets/imgs/mobydyThumbnail.png',
            footerComponent: FooterComponent
        }),
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(CommonModule, FormsModule, RouterModule),
        provideAnimations(),
        { provide: CRBytesPrimeNGAdminConsoleLayoutPreferenceStorageService, useClass: LayoutStorageService }
    ]
};

